module.exports = __webpack_public_path__ + "img/icon_1_9.a982fcd5.png";